import React from 'react'
import { GenericCardSwiper } from '@components/organisms'
import styles from './MagazineSection.module.sass'
import { MagazineNode } from '@gql/graphql'
import { GenericSectionThemeType, MenuItemType } from '@utils/types'
import useTrans from '@hooks/useTrans'
import useTransRoute from '@hooks/useTransRoute'

interface Props {
  refId?: string
  magazines?: MagazineNode[]
  item?: MenuItemType
  theme?: GenericSectionThemeType
  className?: string
}

const MagazineSection = (props: Props) => {
  const {
    refId = undefined,
    magazines = [],
    item = undefined,
    theme = 'neutral10',
    className = '',
  } = props

  const t = useTrans()
  const tRoute = useTransRoute()

  return magazines?.length ? (
    <GenericCardSwiper
      id="magazine-swiper"
      refId={refId}
      item={{
        name: t('Dal nostro blog'),
        ctaLabel: t('Tutte le novità'),
        url: tRoute('/magazine')?.href,
        ...(item || {}), // Override
        children: magazines.map((i) => ({
          pk: i.pk,
          name: i.title,
          image: i.imageUrl,
          tag: i.categoriaTitle,
          url: i.url,
        })),
      }}
      theme={theme}
      className={`${styles.root} ${className}`}
    />
  ) : (
    <></>
  )
}

export default MagazineSection
